<template>
  <modal
    name="modal--edit-task"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="350"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full rounded-sm justify-between p-4"
    >
      <h1
        class="text-center text-4xl font-extralight tracking-tight drag-handler"
      >
        {{ this.new === true ? 'New Task' : 'Edit Task' }}
      </h1>

      <form @submit.prevent="handleConfirm" autocomplete="off">
        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Name
          <input
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="text"
            placeholder="Required"
            v-model.lazy="task.name"
            autocomplete="off"
            :disabled="!isAdmin"
          />
        </label>
        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Additional Description
          <input
            class="text-base font-normal mt-2 focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="text"
            placeholder="Optional"
            v-model.lazy="task.description"
            autocomplete="off"
            :disabled="!isAdmin"
          />
        </label>
        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="frequency"
        >
          Frequency
        </label>
        <div class="mt-2">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
            id="frequency"
            v-model="task.frequency"
            :disabled="!isAdmin"
            @click.stop
          >
            <option value="" disabled selected>select something...</option>
            <option
              v-for="i in settingsTaskFrequencies"
              :key="`${i}-taskFrequency`"
              :value="i"
            >
              {{ i.toString() | capitalize }}
            </option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>

        <label
          v-if="task.frequency === 'weekly'"
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="weekday"
          >Day of the Week
          <div class="mt-2">
            <select
              class="text-base font-normal block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              id="weekday"
              v-model="task.weekday"
              required
              :disabled="!isAdmin"
              @click.stop
            >
              <option value="" disabled selected>select something...</option>
              <option
                v-for="i in 7"
                :key="`${i}-taskWeekday`"
                :value="days[i - 1]"
              >
                {{ days[i - 1] | capitalize }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </label>
        <label
          v-if="
            task.frequency === 'quarterly' ||
              task.frequency === 'bi-annually' ||
              task.frequency === 'annually'
          "
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="month"
        >
          Month

          <div class="mt-2">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              id="month"
              v-model="task.month"
              :disabled="!isAdmin"
              @click.stop
            >
              <option value="" disabled selected>select something...</option>
              <option
                v-for="i in 12"
                :key="`${i}-taskMonth`"
                :value="months[i - 1]"
              >
                {{ months[i - 1] | capitalize }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </label>
        <label
          v-if="
            task.frequency === 'monthly' ||
              task.frequency === 'quarterly' ||
              task.frequency === 'bi-annually' ||
              task.frequency === 'annually'
          "
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="monthDay"
        >
          Day of the Month

          <div class="mt-2">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              id="monthDay"
              v-model="task.monthday"
              :disabled="!isAdmin"
              @click.stop
            >
              <option value="" disabled selected>select something...</option>
              <option
                v-for="i in Array.from({ length: 28 }, (v, k) => k + 1)"
                :key="`${i}-taskMonthDay`"
                :value="i"
              >
                {{ i | capitalize }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </label>

        <div class="mt-4 w-full">
          <label
            class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            for="shift"
          >
            Shift
          </label>
          <div class="mt-2">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              id="shift"
              v-model="task.shift"
              :disabled="!isAdmin"
              @click.stop
            >
              <option value="" disabled selected>select something...</option>
              <option
                v-for="(i, index) in shifts"
                :key="`${i}-shiftName`"
                :value="index"
              >
                {{ i | capitalize }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="mt-4 w-full">
          <label
            class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            for="shift"
          >
            Position
          </label>
          <div class="mt-2">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              id="shift"
              v-model="task.position"
              :disabled="!isAdmin"
              @click.stop
            >
              <option value="" disabled selected>select something...</option>
              <option
                v-for="(i, index) in settingsPositions"
                :key="`${i}-position`"
                :value="index"
              >
                {{ i | capitalize }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="mt-6 flex flex-row justify-between text-lg text-gray-900">
          <span>Send Notification? </span>
          <s-switch v-model="task.notification" :disabled="!isAdmin" />
        </div>

        <transition-expand>
          <div v-if="task.notification">
            <label
              class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
              for="notificationHour"
            >
              Notify If Not Completed By
            </label>
            <div class="mt-2">
              <select
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
                id="notificationHour"
                v-model="task.notificationHour"
                :disabled="!isAdmin"
                @click.stop
              >
                <option value="" disabled selected>select something...</option>
                <option
                  v-for="i in hourNumbers"
                  :key="`${i}-returned`"
                  :value="i"
                  v-text="formatHour(i)"
                />
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </transition-expand>

        <div class="mt-6 flex flex-row justify-between">
          <button
            class="buttonOutline focus:shadow-outline focus:outline-none"
            type="button"
            @click="handleCancel"
          >
            Cancel
          </button>
          <button
            class="ml-3 buttonOutline focus:shadow-outline focus:outline-none"
            v-if="isAdmin && !this.new"
            type="button"
            @click="handleDelete"
          >
            Delete
          </button>
          <button
            v-if="isAdmin"
            class="ml-3 button focus:shadow-outline focus:outline-none"
            type="submit"
          >
            {{ this.new === true ? 'Create' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { days, months, hourNumbers } from '@/const.js'
import { formatHour } from '@/utils.js'
import SSwitch from '@/components/SSwitch.vue'
import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'ModalEditTask',
  data() {
    return {
      days,
      months,
      hourNumbers,
      new: null,
      originalTask: null,
      task: {
        id: null,
        name: null,
        description: null,
        frequency: null,
        day: null,
        date: null,
        weekday: null, // input purposes
        monthday: null, // input purposes
        month: null, // input purposes
        shift: null,
        position: null,
        status: 'active',
        active: null,
        emailRecipients: null,
        notification: false,
        notificationHour: null
      }
    }
  },
  computed: {
    ...mapGetters('storeModule', ['shifts']),
    ...mapGetters('storeModule/tasks', ['taskById']),
    ...mapGetters('global', ['settingsTaskFrequencies', 'settingsPositions']),
    ...mapGetters('user', ['isAdmin'])
  },
  components: {
    SSwitch,
    TransitionExpand
  },
  methods: {
    formatHour,
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('storeModule', ['createTask', 'updateTask', 'deleteTask']),
    hideModal() {
      this.$modal.hide('modal--edit-task')
    },
    beforeOpen: function(event) {
      // If an ID for a task was passed, get that task info, if not, set blank
      if (
        event &&
        event.params &&
        event.params.id &&
        this.taskById(event.params.id)
      ) {
        this.new = false
        // create a local copy of the task, not a reference, for temporary editing
        this.task = {
          ...this.taskById(event.params.id)
        }
        if (!Object.prototype.hasOwnProperty.call(this.task, 'notification'))
          this.$set(this.task, 'notification', false)
      } else {
        this.new = true
        this.task.shift = event.params.shift
        this.task.frequency = 'daily' //event.params.frequency || 'daily'
      }

      // not using Vue.set since this doesn't need to be reactive?
      this.originalTask = { ...this.task }
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose: function() {
      this.originalTask = {}
      Object.keys(this.task).forEach(property => {
        this.task[property] = null
      })
      this.task.status = 'active'
      this.task.active = true
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    handleDelete: function() {
      this.deleteTask(this.task.id)
      this.hideModal()
    },
    handleCancel: function() {
      this.hideModal()
    },
    handleConfirm: function() {
      // later add object comparison to determine if update actually needs pushed
      if (this.new) {
        this.createTask({ ...this.task })
      } else {
        this.updateTask({ id: this.task.id, data: { ...this.task } })
      }
      this.hideModal()
    }
  }
}
</script>
